import CourseProgress from "@/components/course-progress/CourseProgress";

export default function AdminCourseProgress() {
  return <CourseProgress mode="admin" />;
}
